import math from 'mathjs';
import MathParserUtil from './math-parser';

export const VariableTypes = {
    INT: 'INT',
    FLOAT: 'FLOAT',
    FRACTION: 'FRACTION',
    SCIENTIFIC_NOTATION:'SCIENTIFIC_NOTATION',
    LIST:'LIST'
}


function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = s+"0" ;
    return s;
}

export const toScientificNotation = (value, limit) => {
    let sign = value < 0 ? "-" : "";
    let absValue = Math.abs(value);

    let power = Math.floor(Math.log10(absValue));
    let coefficient = (absValue / Math.pow(10, power)).toFixed(limit);
    return `${sign}${coefficient} \\times 10^${power}`;
}

export const  formatScientificNotation = (value,options)=> {
 /*
 50.42  Req Whole 1 digit => 5.042 x e 1
reqWhole = 1
indexofdot = 2
reqWhole -indexofdot = -1

New Dot Position =  indexofdot +(- 1) = 1

power of 10 = indexofdot - newDotPosition =  2 -1 = 1
 
 */

 if(options){
     if(options.requiredWholeNumber)
     {
       
        const requiredWholeNumber = options.requiredWholeNumber;
        
        let indexOfDot = value.indexOf('.');
        if(indexOfDot === -1)
            indexOfDot = value.length;
        
        const wholeNumberString = value.substring(0, indexOfDot);
        const wholeNumberInt = parseInt(wholeNumberString, 10);
        const decimalNumberString = value.substring(indexOfDot + 1, value.length);
        
        const decimalNumberInt = parseInt(decimalNumberString, 10);
        
        let significantDigitPostion = 0;
        
        if(wholeNumberInt === 0){
            significantDigitPostion =( decimalNumberString.length - decimalNumberInt.toString().length)+1;
            
        }

        const disanceFromDot = (requiredWholeNumber) - indexOfDot;
        const newDotPosition = indexOfDot +significantDigitPostion+ disanceFromDot;

         
        console.log('value',value);
        
        console.log('requiredWholeNumber',requiredWholeNumber);
        console.log('indexOfDot',indexOfDot);
        console.log('disanceFromDot',disanceFromDot);
        console.log('newDotPosition',newDotPosition);
        

      



        const powerOfTen = indexOfDot - newDotPosition;
        let noDotNumber = value.replace('.','');
        let dotStr = '.';
        let ePowerString = ' \\times 10^'+powerOfTen;
        
        let optPrecision = (parseInt(options.precision,10));

       


        if(newDotPosition >= noDotNumber.length){
            dotStr = dotStr+'0';
        }

        if(newDotPosition > noDotNumber.length){
            noDotNumber = pad(noDotNumber,newDotPosition)
        }


        console.log('noDotNumber',noDotNumber);


        if(newDotPosition <= 0){
            dotStr = '0'+dotStr;
        }

        if(powerOfTen === 0){
            ePowerString = '';
        }

       
        
        const newFloatNumber = parseFloat(noDotNumber.substring(0,newDotPosition) + dotStr+noDotNumber.substring(newDotPosition, noDotNumber.length)).toFixed(optPrecision);
        
    
         
        return  newFloatNumber+ePowerString;
     }
        
 }
 

 return value;
}
//export const VariableTypes = ['INT','FLOAT','FRACTION'];
export class DynamicQuestionVariable{
    
    constructor(){
        this.name = undefined;
        this.type = undefined;
        this.min = 0;
        this.max = 0;
        this.value = 0;
        this.formattedValue = '';
        this.decimalLimit = '2';
        this.staticValues = '';
        this.numberLength = '0';
        this.precision = '0';
        this.sigFig = '3';
    }

    static generateValue(variable){
        const blackList = stringToNumberArray(variable.rpBlackList);
        if(variable.type && variable.type !== ''){
           // console.log('generateValue variable',variable);
           let validValue = false;
           switch(variable.type){
            case VariableTypes.INT:     
            while(!validValue){
                variable.value = math.randomInt(parseInt(variable.min,10),parseInt(variable.max,10)+1);
               
                
                if(blackList.find((num)=>{
                    return parseInt(variable.value,10)===parseInt(num,10)
                 }) === undefined){
                  validValue = true;
                 }
                 
                variable.formattedValue = variable.value.toString();
            }      
            break;
            case VariableTypes.FLOAT:
            const sigFig = variable.sigFig?variable.sigFig:3;
            while(!validValue){
                const genFloatValue = (Math.random() * (parseFloat(variable.max,10) - parseFloat(variable.min,10)) + parseFloat(variable.min,10));
                variable.value = MathParserUtil.ToPlainString(genFloatValue.toPrecision(sigFig));
                if(blackList.find((num)=>{
                    return parseFloat(variable.value)===parseFloat(num)
                 }) === undefined){
                     validValue = true;
                 }
                variable.formattedValue = variable.value.toString();
            }
            break;
            case VariableTypes.FRACTION:
           // console.log('VariableTypes.FRACTION');
            if(variable.staticValues){
                const valuesArray = variable.staticValues.split(',');
                if(valuesArray && valuesArray.length > 0){
                    variable.value = valuesArray[math.randomInt(0,valuesArray.length)];
                    variable.formattedValue = variable.value.toString();
                }
            }
            
            break;
            case VariableTypes.SCIENTIFIC_NOTATION:
                if(variable.numberLength){
                    
                    while(!validValue){
                        const generatedFloatValue = (Math.random() * (Number(variable.max) - Number(variable.min)) + parseFloat(variable.min,10));
                        const expString = formatScientificNotation(generatedFloatValue.toString(),{requiredWholeNumber:parseInt(variable.numberLength,10),precision:parseInt(variable.precision,10)});
                        // variable.formattedValue = '`'+expString+'`'
                        variable.formattedValue = expString.replace(/\^(-?\d+)\s*/g, '^{$1}')
                        variable.value = math.eval(expString.replace(' \\times ','*'));
                        if(blackList.find((num)=>{
                         return parseFloat(variable.value)===parseFloat(num)
                         }) === undefined){
                          validValue = true;
                         }
                    }
                }
            break;
            case VariableTypes.LIST:
              // console.log('VariableTypes.FRACTION');
               if(variable.listValues){
                   const valuesArray = variable.listValues.split(',');
                   if(valuesArray && valuesArray.length > 0){
                       variable.value = valuesArray[math.randomInt(0,valuesArray.length)];
                       variable.formattedValue = variable.value;
                   }
               }
               
            break;
            default:
            break;
        }

         
     }
    }
}


const stringToNumberArray = (rpBlackList) =>{
    if(rpBlackList){
        const arrRpBlackList = [];
        rpBlackList.split(",").forEach(strNum => {
            if(strNum.includes(".") || strNum.includes("e")){
                arrRpBlackList.push(parseFloat(strNum));
            }else{
                arrRpBlackList.push(parseInt(strNum,10));
            }
        });

        return arrRpBlackList;
    }

    return [];
}

export class VariableMap extends Map{

    containsAll = function(targetMap){
        if(targetMap &&  (targetMap instanceof Map) ){
            for (var key of this.keys()) {
                if(!targetMap.has(key))
                    return false;
            }
        }else{
            throw new Error("Method containsAll : argument not of type map")
        }    

        return true;
    }

    isValid = function(){
        for (var value of this.values()) {
            if(value.type === VariableTypes.SCIENTIFIC_NOTATION){
                return true;
            }
            if(value.type == VariableTypes.LIST){
                if(value.listValues && value.listValues.length > 0)
                {
                    return true;
                }else{
                    return false;
                }
            }

            if(parseFloat(value.min) >= parseFloat(value.max)){
                return false;
            }
        }

        return true;
    }

    getValidationError = function(){
        let validationError = '';
        this.forEach(
            (value, key, map) => {
                if(value.min >= value.max){
                    validationError +=`The min value is greater than or equal to max value for variable ${key}\n` 
                }
            }
        );

        return validationError;
    }

    //Validates and Generates Values for the Variables in Map
    //Throws Error if Validation Failes
    generateValues = function(){
        this.forEach(
            (value, key, map) => {
                DynamicQuestionVariable.generateValue(value);
            }
        );
    }

    static encodeKey(key) {
        return encodeURIComponent(key);
    }

    // Method to decode keys
    static decodeKey(encodedKey) {
        return decodeURIComponent(encodedKey);
    }

    static fromString(str) {
        const obj = JSON.parse(str);
        const variableMap = new VariableMap();
        for (const [encodedKey, value] of Object.entries(obj)) {
            const key = VariableMap.decodeKey(encodedKey);
            variableMap.set(key, value);
        }
        return variableMap;
    }

    toString() {
        const obj = {};
        this.forEach((value, key) => {
            const encodedKey = VariableMap.encodeKey(key);
            obj[encodedKey] = value;
        });
        return JSON.stringify(obj);
    }
}

export class AnswerFormulaMap extends Map{

    
}